import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const coverages = [
    {
        id: "life",
        title: "Life Insurance",
        desc: "Term plans and endowment policies that secure your family's future.",
        tag: "Term · ULIP · Endowment",
        img: "https://images.unsplash.com/photo-1760633549227-901e0c3cf9d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxmYW1pbHklMjBwb3J0cmFpdCUyMG5hdHVyYWwlMjBsaWdodGluZyUyMG91dGRvb3J8ZW58MHx8fHwxNzg1OTM2ODIyfDA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-7",
        h: "h-[380px] md:h-[480px]",
    },
    {
        id: "health",
        title: "Health Insurance",
        desc: "Family floaters, senior citizen covers and top-ups with cashless hospitals across Coimbatore.",
        tag: "Floater · Senior · Top-up",
        img: "https://images.unsplash.com/photo-1625690988276-0a7b0cdf3d5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzb3BoaXN0aWNhdGVkJTIwb2xkZXIlMjBjb3VwbGUlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODU5MzY4MzZ8MA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-5",
        h: "h-[380px] md:h-[480px]",
    },
    {
        id: "motor",
        title: "Motor Insurance",
        desc: "Comprehensive car and two-wheeler covers with instant renewal and claim support.",
        tag: "Car · Two-wheeler · Commercial",
        img: "https://images.unsplash.com/photo-1587750059638-e7e8c43b99fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxjbGFzc2ljJTIwY2FyJTIwbW9vZHklMjBsaWdodGluZ3xlbnwwfHx8fDE3ODU5MzY4MjJ8MA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-5",
        h: "h-[380px] md:h-[440px]",
    },
    {
        id: "home",
        title: "Home Insurance",
        desc: "Protect your house and everything in it against fire, flood and burglary.",
        tag: "Structure · Contents",
        img: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwaG91c2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg1OTM2ODI0fDA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-7",
        h: "h-[380px] md:h-[440px]",
    },
    {
        id: "business",
        title: "Business Insurance",
        desc: "Fire, liability, group health and asset covers for Coimbatore's MSMEs and industries.",
        tag: "Fire · Liability · Group Health",
        img: "https://images.unsplash.com/photo-1675869940341-d495d49010b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG93bmVyJTIwcG9ydHJhaXQlMjBvZmZpY2V8ZW58MHx8fHwxNzg1OTM2ODIyfDA&ixlib=rb-4.1.0&q=85",
        span: "lg:col-span-12",
        h: "h-[380px] md:h-[420px]",
    },
];

export const Coverages = () => (
    <section id="coverages" data-testid="coverages-section" className="mx-auto max-w-7xl px-6 py-32 md:px-12">
        <Reveal className="mb-20 flex flex-col justify-between gap-6 md:flex-row md:items-end">
            <div>
                <p className="mb-6 font-mono text-xs uppercase tracking-[0.25em] text-clay">What we cover</p>
                <h2 className="max-w-xl font-serif text-4xl font-medium leading-none tracking-tight md:text-6xl">
                    Five ways we protect <span className="italic text-clay">your world</span>
                </h2>
            </div>
            <p className="max-w-xs font-mono text-xs uppercase leading-relaxed tracking-[0.15em] text-moss">
                From every major insurer in India — compared side by side
            </p>
        </Reveal>
        <div className="grid grid-cols-1 gap-px border border-line bg-line lg:grid-cols-12">
            {coverages.map((c, i) => (
                <Reveal key={c.id} delay={(i % 2) * 0.08} className={`${c.span} bg-bone`}>
                    <a href="#quote" data-testid={`coverage-card-${c.id}`} className="group block">
                        <div className={`overflow-hidden ${c.h}`}>
                            <img
                                src={c.img}
                                alt={c.title}
                                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                        </div>
                        <div className="flex items-start justify-between gap-6 p-8 md:p-10">
                            <div>
                                <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.2em] text-clay">{c.tag}</p>
                                <h3 className="font-serif text-2xl font-medium md:text-3xl">{c.title}</h3>
                                <p className="mt-3 max-w-md text-sm leading-relaxed text-moss md:text-base">{c.desc}</p>
                            </div>
                            <span className="mt-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-line transition-colors duration-300 group-hover:border-clay group-hover:bg-clay group-hover:text-bone">
                                <ArrowUpRight size={18} />
                            </span>
                        </div>
                    </a>
                </Reveal>
            ))}
        </div>
    </section>
);
